import { render } from "./schoolSafePolicy.vue?vue&type=template&id=28719198&scoped=true"
import script from "./schoolSafePolicy.vue?vue&type=script&lang=js"
export * from "./schoolSafePolicy.vue?vue&type=script&lang=js"

import "./schoolSafePolicy.vue?vue&type=style&index=0&id=28719198&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28719198"]])

export default __exports__